import React from "react";
import BodyContentHeader from "../common/BodyContentHeader";
import "./Portfolio.scss";
import PillTag from "../common/PillTag";

const Portfolio = () => {
  return (
    <div className="body_content_container_child">
      <BodyContentHeader
        headerTitle="Portfolio"
        headerSubtitle="View some of my projects."
        imgSrc="notebook.svg"
        imgAlt="notebook image"
      />
      <div id="portfolio_projects">
        <div className="ux_portfolio_project_container">
          <div className="ux_project_thumbnail_container">
            <img
              className="ux_project_thumbnail"
              src="mc_techapp_screenshots.png"
              alt="maidcentral tech app project thumbnail"
            />
          </div>
          <div className="ux_portfolio_project_text">
            <div className="ux_portfolio_project_flexbox">
              <h2 className="ux_portfolio_project_h2">
                MaidCentral Technician App
              </h2>
              <div className="pill_flexbox wrap">
                <PillTag label={"Mobile App Dev"} color={"green"} />
                <PillTag label={"Flutter/Dart"} color={"green"} />
                <PillTag label={"UX Design"} color={"pink"} />
                <PillTag label={"APIs"} color={"blue"} />
              </div>
            </div>
            <h3 className="ux_portfolio_project_h3">
              This is a published app for cleaning technicians of MaidCentral
              client companies to view their schedules, clock in, check into
              jobs, take breaks, provide feedback on jobs, and more.
              Offline-first, responsive, and supports multiple languages.
            </h3>
            <div style={{ display: "flex", gridGap: "10px" }}>
              <a
                href="https://play.google.com/store/apps/details?id=maidcentral.techapp&hl=en"
                target="_"
                className="purple_btn "
              >
                Download for Android
              </a>
              <a
                href="https://apps.apple.com/us/app/maidcentral-technician/id6502119888"
                target="_"
                className="purple_btn "
              >
                Download for iOS
              </a>
            </div>
          </div>
        </div>

        <div className="ux_portfolio_project_container">
          <div className="ux_project_thumbnail_container">
            <img
              className="ux_project_thumbnail"
              src="mc_profit_thumbnail.png"
              alt="maidcentral profit calculation project thumbnail"
            />
          </div>
          <div className="ux_portfolio_project_text">
            <div className="ux_portfolio_project_flexbox">
              <h2 className="ux_portfolio_project_h2">
                MaidCentral Profit Improvement Calculator
              </h2>
              <div className="pill_flexbox wrap">
                <PillTag label={"Web Dev"} color={"blue"} />
                <PillTag label={"Angular"} color={"blue"} />
                <PillTag label={"TypeScript"} color={"blue"} />
              </div>
            </div>
            <h3 className="ux_portfolio_project_h3">
              This is a proof-of-concept web app that predicts profit change
              over time, according to the business metrics of cleaning service
              companies.
            </h3>
            <div style={{ display: "flex", gridGap: "10px" }}>
              <a
                href="https://maidcentral.taadland.net/"
                target="_"
                className="purple_btn "
              >
                Visit the website
              </a>
              <a
                href="https://github.com/ZontarZon/toto-maidcentral-rate-increase-outcome-calculator"
                target="_"
                className="purple_btn "
              >
                View the source code
              </a>
            </div>
          </div>
        </div>

        <div className="ux_portfolio_project_container">
          <div className="ux_project_thumbnail_container">
            <img
              className="ux_project_thumbnail"
              src="pokedex_thumbnail.png"
              alt="pokedex project thumbnail"
            />
          </div>
          <div className="ux_portfolio_project_text">
            <div className="ux_portfolio_project_flexbox">
              <h2 className="ux_portfolio_project_h2">Toto&apos;s Pokédex</h2>
              <div className="pill_flexbox wrap">
                <PillTag label={"Web Dev"} color={"blue"} />
                <PillTag label={"React"} color={"blue"} />
                <PillTag label={"APIs"} color={"blue"} />
                <PillTag label={"TypeScript"} color={"blue"} />
              </div>
            </div>
            <h3 className="ux_portfolio_project_h3">
              This is a live, functional PWA (Progressive Web App) that fetches
              Pokémon information from the community driven, public Pokémon API.
            </h3>
            <div style={{ display: "flex", gridGap: "10px" }}>
              <a
                href="https://pokedex.taadland.net/"
                target="_"
                className="purple_btn "
              >
                Visit the website
              </a>
              <a
                href="https://github.com/ZontarZon/taadland_pokemon"
                target="_"
                className="purple_btn "
              >
                View the source code
              </a>
            </div>
          </div>
        </div>

        <div className="ux_portfolio_project_container">
          <div className="ux_project_thumbnail_container">
            <img
              className="ux_project_thumbnail"
              src="auctionart_screens_thumbnail.png"
              alt="auctionart thumbnail"
            />
          </div>
          <div className="ux_portfolio_project_text">
            {" "}
            <div className="ux_portfolio_project_flexbox">
              <h2 className="ux_portfolio_project_h2">AuctionArt</h2>
              <div className="pill_flexbox wrap">
                <PillTag label={"UX Design"} color={"pink"} />
                <PillTag label={"Figma"} color={"pink"} />
              </div>
            </div>
            <h3 className="ux_portfolio_project_h3">
              Google UX Certification project. This app prototype is designed
              for bids on online art auctions. In addition, the AuctionArt app
              aims to address diversity and inclusivity issues with contemporary
              art auctions, as well as provide auction opportunities for smaller
              artists and art hobbyists from around the world.
            </h3>
            <a href="/portfolio/AuctionArt" className="purple_btn ">
              View Case Study
            </a>
          </div>
        </div>

        <div className="ux_portfolio_project_container">
          <div className="ux_project_thumbnail_container">
            <img
              className="ux_project_thumbnail"
              src="catmatch_screens_thumbnail.png"
              alt="catmatch thumbnail"
            />
          </div>
          <div className="ux_portfolio_project_text">
            <div className="ux_portfolio_project_flexbox">
              <h2 className="ux_portfolio_project_h2">CatMatch</h2>
              <div className="pill_flexbox wrap">
                <PillTag label={"UX Design"} color={"pink"} />
                <PillTag label={"Adobe XD"} color={"pink"} />
              </div>
            </div>
            <h3 className="ux_portfolio_project_h3">
              Google UX Certification project. This website prototype is
              designed to facilitate cat adoptions and matches users with cats,
              based on the unique personalities of the cats using playfulness,
              affection, energy, and talkative scores.
            </h3>

            <a href="/portfolio/CatMatch" className="purple_btn ">
              View Case Study
            </a>
          </div>
        </div>

        <div className="ux_portfolio_project_container">
          <div className="ux_project_thumbnail_container">
            <img
              className="ux_project_thumbnail"
              src="beekind_screens_thumbnail.png"
              alt="bee kind thumbnail"
            />
          </div>
          <div className="ux_portfolio_project_text">
            <div className="ux_portfolio_project_flexbox">
              <h2 className="ux_portfolio_project_h2">Bee Kind</h2>
              <div className="pill_flexbox wrap">
                <PillTag label={"UX Design"} color={"pink"} />
                <PillTag label={"Figma"} color={"pink"} />
              </div>
            </div>
            <h3 className="ux_portfolio_project_h3">
              Google UX Certification project. Bee Kind, the dedicated mobile
              app and website prototype designed to teach the public about bee
              conservation efforts. Search for native plants in your area, and
              find care instructions to help restore the natural habitat of
              bees.
            </h3>

            <a href="/portfolio/BeeKind" className="purple_btn ">
              View Case Study
            </a>
          </div>
        </div>

        <div className="ux_portfolio_project_container">
          <div className="ux_project_thumbnail_container">
            <img
              className="ux_project_thumbnail"
              src="terminalrim_thumbnail.jpg"
              alt="terminal rim game thumbnail"
            />
          </div>
          <div className="ux_portfolio_project_text">
            <div className="ux_portfolio_project_flexbox">
              <h2 className="ux_portfolio_project_h2">Terminal Rim</h2>
              <div className="pill_flexbox wrap">
                <PillTag label={"Game Dev"} color={"green"} />
                <PillTag label={"C#"} color={"green"} />
                <PillTag label={"UX Design"} color={"pink"} />
                <PillTag label={"Figma"} color={"pink"} />
              </div>
            </div>
            <h3 className="ux_portfolio_project_h3">
              This is a Unity3D tower defense shooter, in which the player
              defends their space station against an alien invasion using
              turrets and a player controlled ship.
            </h3>
            <div style={{ display: "flex", gridGap: "10px" }}>
              <a href="/portfolio/TerminalRim" className="purple_btn">
                View Case Study
              </a>
              <a
                href="https://zockchster.itch.io/terminal-rim"
                className="purple_btn"
              >
                Play the game
              </a>
            </div>
          </div>
        </div>

        <div className="ux_portfolio_project_container">
          <div className="ux_project_thumbnail_container">
            <img
              className="ux_project_thumbnail"
              src="space_cat_game_thumbnail.png"
              alt="space cat game thumbnail"
            />
          </div>
          <div className="ux_portfolio_project_text">
            <div className="ux_portfolio_project_flexbox">
              <h2 className="ux_portfolio_project_h2">Edgar the Space Cat</h2>
              <div className="pill_flexbox wrap">
                <PillTag label={"Game Dev"} color={"green"} />
                <PillTag label={"React"} color={"blue"} />
              </div>
            </div>
            <h3 className="ux_portfolio_project_h3">
              This is a small browser game using Three.js and WebGL.
            </h3>

            <a href="/game" className="purple_btn ">
              Play the game
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
